<template>
  <div
    :class="['ec-home', isCollapse ? 'hideSideBar' : 'openSideBar']"
    @click="clicked"
  >
    <ec-side-bar />
    <div class="ec-container">
      <ec-header />
      <div class="ec-content">
        <ec-tags-view></ec-tags-view>
        <div class="ec-main">
          <keep-alive :include="cachedViews">
            <router-view></router-view>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EcHeader from "./layout/EcHeader";
import EcSideBar from "./layout/EcSideBar";
import EcTagsView from "./components/EcTagsView/index";
// import Watermark from '../../common/utils/watermark.js'
export default {
  components: {
    EcHeader,
    EcSideBar,
    EcTagsView,
  },
  data() {
    return {
      // 最大非活动时间间隔，单位ms
      lastActiveTime: new Date().getTime(),
      maxInactiveInterval: 20 * 60 * 1000,
    };
  },
  provide() {
    return {
      UpdateLogout: this.UpdateLogout,
      lastActiveTimeFn: () => this.lastActiveTime,
      maxInactiveInterval: this.maxInactiveInterval,
    };
  },
  computed: {
    ...mapState([
      "isCollapse",
      "permissUpdateFlag",
      "userName",
      "orgAddr",
      "orgCode",
      "orgNames",
      "cachedViews"
    ]),
  },
  mounted() {
    const _this = this;
    _this.$nextTick(function () {
      _this.preventDocumentRightClick();
    });
    // this.writeWaterMark()
  },
  beforeDestroy() {
    // Watermark.remove()
  },
  methods: {
    writeWaterMark() {
      let watermarkStr = "";
      let orgName = this.orgNames.length > 0 ? this.orgNames[0] : "";
      let watermarkArr = [this.userName, this.orgCode, orgName];
      watermarkArr.forEach((val, index) => {
        let dot = index == watermarkArr.length - 1 ? "" : ",";
        if (val) {
          watermarkStr += val + dot;
        }
      });
      Watermark.set(watermarkStr);
    },
    async UpdateLogout(flag) {
      let _this = this;
      _this.$store.commit("SET_LOGIN", false);
      if (_this.$store.state.permissUpdateFlag) {
        // 如果修改了权限则退出到登录页面时清空路由
        _this.$router.go(0);
      } else _this.$router.push({ path: "/login" });
      if (flag) {
        await _this.Api.loginOut();
      }
    },
    // 更新上次活动时间
    async clicked() {
      let _this = this;
      let currentActiveTime = new Date().getTime();
      if (
        currentActiveTime - _this.lastActiveTime >
        _this.maxInactiveInterval
      ) {
        _this.$message({
          showClose: true,
          message: "登录超时，请重新登录!",
          type: "warning",
        });
        _this.UpdateLogout();
      } else {
        _this.lastActiveTime = currentActiveTime;
      }
    },
    preventDocumentRightClick() {
      document.oncontextmenu = function () {
        return false;
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/theme/variables.scss";
.ec {
  &-main {
    padding: 12px 16px;
    background: #f5f5f5;
    // height: 90vh;
    // overflow-y: scroll;
  }
  &-content {
    margin-top: 4px;
  }
  &-sidebar {
    width: 200px;
    background: rgb(0, 96, 164);
    height: 100%;
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
    bottom: 0;
    -webkit-transition: width 0.28s;
    transition: width 0.28s;
  }
  &-container {
    transition-duration: .28s;
    padding-top: 50px;
    margin-left: 200px;
    position: relative;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue